import { Link, router } from '@inertiajs/react'
import Seo from '../components/Seo'
import PackArtwork from '../components/PackArtwork'
import { useShared } from '../lib/hooks'
import type { LibraryItem } from '../lib/types'

export default function Account({ library }: { library: LibraryItem[] }) {
  const { auth } = useShared()

  return (
    <>
      <Seo title="Your library" noindex />
      <div className="mx-auto max-w-4xl px-4 sm:px-6 py-12">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="mono-label mb-2">Account</div>
            <h1 className="text-3xl font-semibold tracking-tight">Your library</h1>
            {auth.user && <p className="mt-1 text-muted text-sm">{auth.user.email}</p>}
          </div>
          <button
            type="button"
            onClick={() => router.delete('/logout')}
            className="mono-label border border-line px-4 py-2 hover:border-line-2 transition-colors"
          >
            Sign out
          </button>
        </div>

        {library.length === 0 ? (
          <div className="mt-10 border border-line p-10 text-center">
            <p className="text-muted">You haven't purchased any packs yet.</p>
            <Link href="/packs" className="inline-grid place-items-center mt-6 h-11 px-6 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition">
              Browse catalog →
            </Link>
          </div>
        ) : (
          <div className="mt-8 space-y-4">
            {library.map((item) => (
              <div key={item.id} className="border border-line p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="size-16 shrink-0 border border-line overflow-hidden">
                  <PackArtwork pack={item} size="thumb" />
                </div>
                <div className="flex-1 min-w-0">
                  <Link href={item.url} className="font-medium hover:text-paper">{item.name}</Link>
                  <div className="mono-label mt-1">{item.type_label} · {item.catalog_number}</div>
                </div>
                <div className="flex flex-wrap gap-2">
                  {item.downloads.length === 0 ? (
                    <span className="mono-label text-muted">Files coming soon</span>
                  ) : (
                    item.downloads.map((dl) => (
                      <a
                        key={dl.url}
                        href={dl.url}
                        className="inline-grid place-items-center h-11 px-5 bg-paper text-ink text-sm font-semibold hover:opacity-90 transition"
                      >
                        Download {dl.kind === 'presets' ? 'pack' : dl.filename}
                      </a>
                    ))
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  )
}
